<template>
  <div class="accordion-select" :class="accordionReferenceClassObject" :id="accordionReferenceId">
    <div :class="classNames">
      <div class="position-absolute">
        <div class="select pl-3" :class="secondClassNames">
          <a
            href="javascript:void(0);"
            data-href="#"
            target=""
            data-toggle="collapse"
            :data-target="'#'+ collapseReferenceId"
            aria-expanded="false"
            :aria-controls="collapseReferenceId"
            >{{placeholderValue}}</a
          >
        </div>
        <div
          :id="collapseReferenceId"
          class="collapse"
          :aria-labelledby="'heading-select-' + id"
          :data-parent="'#' + accordionReferenceId"
        >
          <div class="inner-select-accordion thin-scrollable">
            <a
              href="javascript:void(0);"
              data-href="#"
              v-for="(item, index) in valuesList" :key="index"
              @click="selectItem(index)"
              >{{item[valueKey]}}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SelectComponent",
  data() {
    return {
      placeholderValue: ''
    }
  },
  props: {
    id: String,
    placeholder: String,
    value: Object,
    valueKey: String,
    valuesList: Array,
    classNames: String,
    secondClassNames: String,
  },
  mounted() {
    this.placeholderValue = this.placeholder;
    if (this.valueInternal) {
      this.placeholderValue = this.valueInternal[this.valueKey];
    }
  },
  computed: {
    collapseReferenceId() {
      return 'collapse-select-' + this.id;
    },
    accordionReferenceId() {
      return 'accordion-select-' + this.id;
    },
    accordionReferenceClassObject() {
      let className = this.accordionReferenceId;
      let obj = {}
      obj[className] = true;
      return obj;
    },
    valueInternal: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("update:value", value);
      },
    },
  },
  methods: {
    selectItem(value) {
      let strValue = this.valuesList[value];
      this.valueInternal = strValue;
      this.placeholderValue = strValue[this.valueKey];
      this.closeSelection();
    },
    closeSelection() {
      let el = this.$el.querySelector('.select a');
      el.click();
    }
  },
};
</script>

<style scoped>
</style>
